import React, {FC, PropsWithChildren, createContext, useContext} from 'react';
import {useCompleteLocation} from './react-router';

const PathnameContext = createContext<string>('/');

const SearchContext = createContext<string>('');

export const usePathname = () => useContext(PathnameContext);
export const useSearch = () => useContext(SearchContext);

export const PathnameProvider: FC<PropsWithChildren> = ({children}) => {
  const {pathname} = useCompleteLocation();
  return (
    <PathnameContext.Provider value={pathname}>
      {children}
    </PathnameContext.Provider>
  );
};

export const SearchProvider: FC<PropsWithChildren> = ({children}) => {
  const {search} = useCompleteLocation();
  return (
    <SearchContext.Provider value={search}>{children}</SearchContext.Provider>
  );
};

const LocationStateContext = createContext<any>(undefined);

export const useLocationState = <T extends unknown>() =>
  useContext<T | undefined>(LocationStateContext);

export const LocationStateProvider: FC<PropsWithChildren> = ({children}) => {
  const {state} = useCompleteLocation();
  return (
    <LocationStateContext.Provider value={state}>
      {children}
    </LocationStateContext.Provider>
  );
};
